module.exports = __webpack_public_path__ + "static/media/confirm (1).04d5cb54.png";